module.exports = __webpack_public_path__ + "img/location.72367422.svg";